import chain from 'app/_shared/events/util/chain'
import actionByKey from 'app/_shared/events/action/byKey'
import { detail, persistChange } from 'app/_shared/events'
import persistDynamicForm from 'app/_shared/events/form/dynamic/persist'
import createRedirect from 'app/_shared/events/appbar/createRedirect'
import infinite from 'app/_shared/events/search/infinite'
import save from './event/save'
import clear from './event/clear'
import updateDetail from './event/updateDetail'
import enableButtons from './event/enableButtons'

export default {
  onCreate: {
    createRedirect,
  },
  onOpen: {
    infinite: infinite(null),
  },
  onClick: {
    submit: actionByKey('submit'),
    detail,
    save,
    clear,
  },
  onChange: {
    persistChange,
    persistChangeAndEnableButtons: chain(
      persistChange,
      enableButtons,
    ),
    persistChangeAndUpdateDetail: chain(
      persistChange,
      updateDetail,
    ),
  },
  onFormChange: {
    persistDynamicForm,
  },
}
